<script setup lang="ts">
    import { defaultAutocompleteConverter } from "@/components/forms/inputs/Autocomplete/helpers";
    import { useStore } from "@/store";
    import { flashWarning } from "@/utils";

    const fetchAvtal = async ({ query }: { query?: string } = {}) => {
        const store = useStore();

        try {
            const params: { q?: string } = {};

            if (query) {
                params.q = query;
            }

            const { subsetName } = await store.dispatch("avtal/fetchAvtal", {
                filterParams: params,
                displayMode: true,
            });

            return store.getters["avtal/avtalSubset"]({ subsetName, displayMode: true });
        } catch (error) {
            flashWarning("Kunde inte hämta avtal.");
        }
    };
</script>

<template>
    <KAutocomplete
        v-bind="$attrs"
        name="avtal"
        label="Avtal"
        :options="fetchAvtal"
        :converter="defaultAutocompleteConverter"
    />
</template>

<style lang="scss" scoped></style>
